import axios from "axios";

export const state = {
    commentgroups: [],
};

export const getters = {
    commentgroups: state => state.commentgroups,
};

export const mutations = {
    setCommentGroups(state, newValue) {
        state.commentgroups = newValue
    },
};

export const actions = {
    fetchCommentGroups({ commit }) {
        axios.get('/comment-groups').then(res => {
            commit('setCommentGroups', res.data.comment_groups);
        })
    },
   
};
